import { faHeart as faHeartLight } from "@jewlr/pro-light-svg-icons/faHeart"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { faHeart as faHeartSolid } from "@jewlr/pro-solid-svg-icons/faHeart"
import PropTypes from "prop-types"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { unselectFromWishlist } from "areas/collection/store/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { IS_JEWLR } from "helpers/application"
import { cn } from "styles/utils"

const WishlistIcon = ({ item }) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const wishlistItems = useSelector((state) => state.wishlist.line_items)
  const wishlistLoading = useSelector((state) => state.wishlist.loading)

  const wishlistAdded = useMemo(
    () =>
      (wishlistItems || []).some(
        (line_item) =>
          line_item.style_code === item.style_code ||
          line_item.rm_style_code === item.rm_style_code
      ),
    [wishlistItems, item.rm_style_code, item.style_code]
  )

  const removeFromWishlist = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (wishlistLoading) return null
      const styleCode = item.rm_style_code || item.style_code
      if (wishlistAdded) {
        dispatch(unselectFromWishlist(styleCode, "Wishlist"))
      }
    },
    [
      wishlistLoading,
      wishlistAdded,
      dispatch,
      item.rm_style_code,
      item.style_code,
    ]
  )

  const wishlistName = IS_JEWLR() ? "wish list" : "collection"
  const ariaLabel = loading
    ? `Loading ${wishlistName}`
    : wishlistAdded
      ? `Remove from ${wishlistName}`
      : `Add to ${wishlistName}`

  useEffect(() => {
    if (!wishlistLoading) {
      setLoading(wishlistLoading)
    }
  }, [wishlistLoading])

  return (
    <Button
      aria-label={ariaLabel}
      className="z-1 absolute right-8 top-10"
      disabled={loading}
      onClick={(e) => {
        if (!loading) {
          setLoading(true)
          removeFromWishlist(e)
        }
      }}
      title={ariaLabel}
    >
      {loading ? (
        <FontAwesomeIcon className="text-22" icon={faSpinner} spin />
      ) : (
        <FontAwesomeIcon
          className={cn(
            "text-22",
            wishlistAdded ? "text-wishlist" : "text-black"
          )}
          icon={wishlistAdded ? faHeartSolid : faHeartLight}
        />
      )}
    </Button>
  )
}

WishlistIcon.propTypes = {
  item: PropTypes.object,
}

export default WishlistIcon
